import * as yup from "yup";

export const schema = (
    t: (val: string, values?: { [key: string]: string | number }) => string
) => {
    const validation = {
        name: yup
            .string()
            .max(500, t("cmn:val.maxLenght"))
            .required(t("cmn:val.required")),
    };

    return yup.object().shape({ ...validation });
};
